import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { NgOptimizedImage } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { DomainEventBus, DomainEventType } from '../../events/domain-event-bus';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [NgOptimizedImage],
  templateUrl: './error.component.html',
  styleUrl: './error.component.less'
})
export class ErrorComponent implements OnInit {
  public publicId: string | null = null;
  public traceId: string | null = null;

  constructor(
    private loader: LoaderService,
    private route: ActivatedRoute,
    private bus: DomainEventBus
  ) {}

  ngOnInit(): void {
    this.publicId = this.route.snapshot.queryParamMap.get('publicId');
    this.traceId = this.route.snapshot.queryParamMap.get('traceId');
    const status = this.route.snapshot.queryParamMap.get('status') || this.route.snapshot.data['status'];
    this.bus.emit({ type: DomainEventType.ErrorPageShown, publicId: this.publicId, status: status, url: window?.location?.href } as any);
    setTimeout(() => {
      this.loader.hideLoader();
    });
  }
}
